import { WHITELABEL_CONFIGURATION, whitelabelIdentifier } from '../../../whitelabel/whitelabel-configuration';
import { Injectable } from '@angular/core';
import { Whitelabel, WhitelabelComponentMap, WhitelabelCustomization } from '../contract/whitelabel.contract';
import { IconsetKey } from '../../../whitelabel/iconset-key.enum';
import { ThemeKey } from '../../../whitelabel/theme-key.enum';

@Injectable({
  providedIn: 'root',
})
export class WhitelabelManagerService {

  private getWhitelabelConfiguration(): Whitelabel {
    const config: Whitelabel = WHITELABEL_CONFIGURATION[whitelabelIdentifier];
    if (!config) {
      throw new Error(`Unknown whitelabel context: ${whitelabelIdentifier}`);
    }
    return config;
  }

  public getWhitelabelCustomization(): WhitelabelCustomization | undefined {
    return this.getWhitelabelConfiguration().customization;
  }

  public getAvailableThemes(): ThemeKey[] {
    return this.getWhitelabelConfiguration().availableThemes;
  }

  public getDefaultTheme(): ThemeKey {
    return this.getWhitelabelConfiguration().defaultTheme;
  }

  public getWhitelabelIconSet(): IconsetKey {
    return this.getWhitelabelConfiguration().iconSet;
  }

  public getWhitelabelComponentConfiguration(): WhitelabelComponentMap {
    return this.getWhitelabelConfiguration().whitelabeledComponents;
  }

  public getAllWhitelabelConfigurations(): Record<string, Whitelabel> {
    return WHITELABEL_CONFIGURATION;
  }

  /**
   * Overrides translation strings.
   *
   * This method takes the translation string object which is fetched in translation-utils.ts and overrides
   * specific keys with replacements for whitelabeling. These strings can be found in the respective whitelabel
   * definition files.
   *
   * It expects the definition of the overrides to be in the form
   *
   * translationKeyOverrides: {
   *   'general.customer.s': 'general.org.s',
   *   'general.customer.pl': 'general.org.pl',
   *   'general.label.s': 'general.fleet.s',
   *   'general.label.pl': 'general.fleet.pl',
   * }
   *
   * @param translations
   * @return Record<string, unknown>
   */
  public whitelabelTranslations(translations: Record<string, unknown>): Record<string, unknown> {
    const mappings = this.getWhitelabelCustomization()?.translationKeyOverrides;
    if (mappings) {
      Object.entries(mappings).forEach(([targetPath, sourcePath]) => {

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const value = sourcePath.split('.').reduce((o: any, key: string) => o?.[key], translations);

        if (value !== undefined) {
          const keys = targetPath.split('.');
          const lastKey = keys.pop();
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const target = keys.reduce((o: any, key: string) => o?.[key], translations);
          if (target && lastKey) {
            target[lastKey] = value;
          }
        }
      });
    }
    return translations;
  }

}
